<template>
  <div class="container-table">
    <span>{{ titulo }}</span>
    <table>
      <thead>
        <tr>
          <th>DESCRIÇÃO</th>
          <th>VALOR</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Fixo de Implantação</td>
          <td class="text-right">
            R$
            {{
              fixo.valorImplantacao.toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
              })
            }}
          </td>
        </tr>
        <tr>
          <td>Fixo de Custeio</td>
          <td class="text-right">
            R$
            {{
              fixo.valorCusteio.toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
              })
            }}
          </td>
        </tr>
        <tr>
          <td>Vínculo e acompanhamento</td>
          <td class="text-right">
            R$
            {{
              vinculoAcompanhamento.toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
              })
            }}
          </td>
        </tr>
        <tr>
          <td>Qualidade</td>
          <td class="text-right">
            R$
            {{
              qualidade.toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
              })
            }}
          </td>
        </tr>
        <tr>
          <td>Per capita</td>
          <td class="text-right">
            R$
            {{
              perCapita.toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
              })
            }}
          </td>
        </tr>
        <tr>
          <td>Total</td>
          <td class="text-right">R$ {{ valorTotal }}</td>
        </tr>
      </tbody>
    </table>
    <span class="fonte" v-html="fonte"></span>
  </div>
</template>

<script>
export default {
  props: {
    titulo: {
      type: String,
      default: '',
    },
    numeroQuadro: {
      type: String,
      default: '',
    },
    classificacao: {
      type: String,
      default: '',
    },
    fixo: {
      type: Object,
      default: () => {},
    },
    vinculoAcompanhamento: {
      type: [Number],
      default: 0,
    },
    qualidade: {
      type: [Number],
      default: 0,
    },
    perCapita: {
      type: [Number],
      default: 0,
    },
    fonte: {
      type: String,
      default: '',
    },
  },
  computed: {
    valorTotal() {
      const value =
        this.$props.fixo.valorImplantacao +
        this.$props.fixo.valorCusteio +
        this.$props.vinculoAcompanhamento +
        this.$props.qualidade +
        this.$props.perCapita
      return value.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.container-table {
  @media print {
    margin-bottom: 15px;
  }
  @media screen and (max-width: 1024px) {
    overflow: scroll;
  }
  span {
    display: block;
    width: 100%;
    margin-bottom: 10px;
  }
  table {
    width: 100%;
    border: 1px solid;
    border-collapse: collapse;

    th {
      border: 1px solid black;
      text-align: center;
    }
    td {
      border: 1px solid black;
      padding: 10px;
    }
  }
}
</style>
<style lang="scss"></style>
